import React from 'react';
import { Box, Button, Modal, Table } from '@amzn/awsui-components-react-v3';
import { BulkEntityValidationRecord } from 'src/components/selfServeWorkflows/requirementsPortal/bulkUploadSteps/BulkExecutionStepProgress';

interface BulkAutoPopulationResultsModalProps {
	record: BulkEntityValidationRecord | null;
	onDismiss: () => void;
}

const BulkAutoPopulationResultsModal: React.FC<BulkAutoPopulationResultsModalProps> = ({ record, onDismiss }) => {
	return (
		<Modal
			visible={record !== null}
			onDismiss={onDismiss}
			header={`Auto-Population Results${record?.entityId ? ` — ${record.entityId}` : ''}`}
			footer={
				<Box float="right">
					<Button variant="primary" onClick={onDismiss}>
						Close
					</Button>
				</Box>
			}
		>
			<Table
				columnDefinitions={[
					{
						id: 'key',
						header: 'Attribute',
						cell: (item: { key: string; value: unknown }) => item.key,
					},
					{
						id: 'value',
						header: 'Value',
						cell: (item: { key: string; value: unknown }) => {
							if (Array.isArray(item.value)) return item.value.join(', ');

							if (item.value == null) return '-';

							if (typeof item.value === 'object') return JSON.stringify(item.value);

							return String(item.value);
						},
					},
				]}
				items={Object.entries(record?.autoPopulationResults || {}).map(
					([key, value]) => ({ key, value }),
				)}
				variant="embedded"
				empty={
					<Box textAlign="center" color="inherit">
						<b>No auto-populated attributes</b>
					</Box>
				}
			/>
		</Modal>
	);
};

export default BulkAutoPopulationResultsModal;